<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="gateway_report_filter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#gateway_report_filter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('reports.gateways.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    color="#00c1a4"
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "from_date"
                                                    v-model="query.from_date"
                                                    type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('reports.gateways.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    color="#00c1a4"
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name= "to_date"
                                                    v-model="query.to_date"
                                                    type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="subcategory_code">
                                                {{ $t('label.subcategory_code') }}
                                            </kt-form-label>
                                            <select
                                                    id="subcategory_code"
                                                    name="subcategory_code"
                                                    v-model="query.subcategory_code"
                                                    class="form-control kt-selectpicker"
                                            >
                                                <option
                                                        v-bind:key="subcategory.key"
                                                        v-for="subcategory in subcategories"

                                                        :value="subcategory.key"
                                                >
                                                    {{ subcategory.value }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="subcategory_code">
                                                {{ $t('reports.gateways.shop_type') }}
                                            </kt-form-label>
                                            <select
                                                    id="shop_type"
                                                    name="shop_type"
                                                    v-model="query.shop_type"
                                                    class="form-control kt-selectpicker"
                                            >
                                                <option
                                                        v-for="(shop_type, index) in AllShopTypes"
                                                        v-bind:key="index"
                                                        v-bind:value="shop_type.value"
                                                        :selected="query.shop_type === shop_type.value"
                                                >
                                                    {{ shop_type.name }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                                <kt-form-row>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                            <kt-row>
                                <kt-col xs="12" sm="6" md="6">
                                    <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6">
                                    <button
                                            class="btn btn-success btn-wide float-right"
                                            size="md"
                                            type="button"
                                            id="export_btn"
                                            @click="exportExcel($event, query)"
                                    >
                                        {{ $t('reports.btn.export_transaction_to_excel') }}
                                    </button>
                                </kt-col>
                            </kt-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import {subcategories} from '@/constants/subcategoriesForSearch'
import $ from "jquery";
import { i18n } from '@/plugins/i18n'
import  { AllShopTypes } from "@/constants/AllShopTypes"
import  { AllShopTypesStr } from "@/constants/AllShopTypes"

export default {
        props: {
            action: {
                default: function(e, query) {},
                required: true,
            },
            exportExcel: {
                default: function(e, query) {},
                required: true,
            }
        },
        data() {
            return {
                AllShopTypes: [
                    {
                        name: null,
                        value: null
                    },
                    {
                        name: AllShopTypesStr.PAYMENT_HELPER,
                        value: AllShopTypes.PAYMENT_HELPER,
                    },
                    {
                        name: AllShopTypesStr.PAYMAN,
                        value: AllShopTypes.PAYMAN,
                    },
                    {
                        name: AllShopTypesStr.IVR,
                        value: AllShopTypes.IVR,
                    },
                    {
                        name: AllShopTypesStr.DEDICATED,
                        value: AllShopTypes.DEDICATED,
                    },
                ],
                subcategories: subcategories,
                query: {}
            }
        },
        methods: {
            clearFromDate() {
                if(this.query.from_date) {
                    this.query.from_date = null
                }
            },
            clearToDate() {
                if(this.query.to_date) {
                    this.query.to_date = null
                }
            },
            afterDispatch() {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            },
        },
        mounted() {
            this.afterDispatch()
        },
    }
</script>

<style>

</style>